import * as React from "react";

interface ProminentErrorConsumerInterface {
  prominentError: string | null;
  prominentErrorArea?: string;
  setProminentError: (value: string | null, area?: string) => void; // React.Dispatch<React.SetStateAction<string | null>>;
}

const defaultValue = null as unknown as ProminentErrorConsumerInterface;

const ProminentErrorContext = React.createContext(defaultValue);

export const ProminentErrorProvider: React.FunctionComponent = (props) => {
  const [prominentError, setProminentErrorImmediate] = React.useState<
    string | null
  >(null);
  const [prominentErrorArea, setProminentErrorArea] = React.useState<
    string | undefined
  >(undefined);

  React.useEffect(() => {
    let timeout: number | undefined;
    if (prominentError) {
      timeout = window.setTimeout(() => {
        setProminentErrorImmediate(null);
        setProminentErrorArea(undefined);
      }, 10 * 1000);
    }
    return () => {
      window.clearTimeout(timeout);
    };
  }, [prominentError, setProminentErrorImmediate, setProminentErrorArea]);

  const setProminentError: ProminentErrorConsumerInterface["setProminentError"] =
    React.useCallback(
      (value, area) => {
        setProminentErrorArea(area);
        setProminentErrorImmediate(value);
      },
      [setProminentErrorArea, setProminentErrorImmediate]
    );

  const value: ProminentErrorConsumerInterface = React.useMemo(
    () => ({
      prominentError,
      prominentErrorArea,
      setProminentError,
    }),
    [prominentError, prominentErrorArea, setProminentError]
  );

  return (
    <ProminentErrorContext.Provider value={value}>
      {props.children}
    </ProminentErrorContext.Provider>
  );
};

export const useProminentError = () => {
  const context = React.useContext(ProminentErrorContext);
  if (context === defaultValue) {
    throw new Error(
      "useProminentError must be used within a ProminentErrorProvider"
    );
  }
  return context;
};
